<template>
  <div class="wrapper">
    <side-bar-cidadao>
      
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link to="/painelcidadao/home">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Painel de Controle</p>
      </sidebar-link>
      <sidebar-link to="/painelcidadao/espera">
        <i class="nc-icon nc-time-alarm"></i>
        <p>Manifestos em Espera</p>
        <span class="notification-menu">{{manifestacao_exibir.length}}</span>
      </sidebar-link>
      <sidebar-link to="/painelcidadao/minhasmanifestacoes">
        <i class="nc-icon nc-notes"></i>
        <p>Minhas Manifestações</p>
      </sidebar-link>
    </side-bar-cidadao>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
  import 'src/controller/sistema/manifestacaoController.js'
  import 'src/controller/cidadao/cidadaoController.js'
  import TopNavbar from './CidadaoTopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenuCidadao.vue'
  import store_cidadao from "src/storeCidadao.js"
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data () {
      return {
        manifestacao:null,
        manifestacao_exibir:[],
        me:null,
        espera: 0,
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      async listarTudo(){
        try {
            let data = await this.$listarManifestosCidadao(store_cidadao.id_cidadao);
            this.manifestacao = data.data;
          
            let s = await this.$secretaria();
            let secretarias = s.data;

            this.manifestacao.forEach(array => {
                this.filtro(array,secretarias);
            });

        }catch(e){

        }
      },
      async filtro(array,secretarias) {
         try {
            
              let assunto;
              let secretaria;
              
              secretarias.forEach(element => {
                if(array.secretaria == element.id){
                    secretaria = element.secretaria;
                }
              });
              
              let numero_manifesto;
              if(array.anonimo == 1){
                 numero_manifesto = 'Anônimo';
              }else{
                 numero_manifesto = array.uuid;
              }
             
             if(this.me == array.cidadao_login){
                if(array.abertura == "Espera"){
                    let manifesto={
                        uuid: array.uuid,
                        numero_manifesto: numero_manifesto,
                        tipo_assunto: array.tipo_assunto,
                        assunto: array.assunto,
                        secretaria: secretaria,
                        abertura: array.abertura,
                        conteudo: array.conteudo,
                        cidadao_login: array.cidadao_login,
                        anonimo: array.anonimo,
                        numero: array.numero,
                        complemento: array.complemento,
                        rua: array.rua,
                        bairro: array.bairro,
                    };
                    this.manifestacao_exibir.push(manifesto);
                }
              }

            this.espera = sessionStorage.getItem("espera");
             
          
         } catch (error) {
           //console.log(error);
         }
      },
        
    },
    beforeMount(){
        try {
          this.listarTudo();
        } catch (e) {
          throw e;
        }
    }
  }

</script>
<style>
  .notification-menu {
    position: absolute;
    background-color: #FB404B;
    text-align: center;
    border-radius: 10px;
    min-width: 18px;
    padding: 0 5px;
    height: 18px;
    font-size: 12px;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 18px;
    right: 19px;
  }
</style>

